var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.display)?_c('v-btn',{on:{"click":function($event){return _vm.btnClickedHandler()}}},[_vm._v(_vm._s(_vm.name))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }